import { colors } from '../../../theme/color-palette';
import {
	BOGLE_MEDIUM,
	BOGLE_REGULAR,
	BOGLE_LIGHT,
} from '../../../constants/constant';

export const addItemsStyles = {
	title: {
		padding: '24px',
		fontFamily: BOGLE_LIGHT,
		fontSize: '18px',
		color: colors.FONT_COLOR,
	},
	searchBox: {
		'& legend': { display: 'none' },
		'& fieldset': { top: 0 },
		width: '100%',
		height: '54px',
	},
	searchIconColor: { color: colors.PURPLE, marginRight: '14px' },
	searchBoxInput: {
		style: {
			fontSize: '14px',
			fontFamily: BOGLE_REGULAR,
			color: colors.FONT_COLOR,
			fontWeight: 400,
		},
	},
	pasteItemLink: {
		textTransform: 'none',
		fontSize: '14px',
		fontFamily: BOGLE_MEDIUM,
		padding: 0,
		color: colors.PURPLE,
		backgroundColor: 'transparent',
		marginLeft: '14px',
	},
	checkBoxForm: {
		display: 'flex',
		flexDirection: 'row',
		marginTop: '24px',
	},
	checkBox: { color: colors.PURPLE },
	checkBoxText: { fontFamily: BOGLE_LIGHT, fontSize: 16 },
	resultBox: { flexGrow: 1, marginTop: '12px' },
	searchResults: {
		fontFamily: BOGLE_LIGHT,
		fontSize: '16px',
		color: colors.FONT_COLOR,
		marginTop: 24,
	},
	cancelButton: {
		textTransform: 'none',
		fontSize: 14,
		fontFamily: BOGLE_MEDIUM,
		borderRadius: 24,
		color: colors.PURPLE,
		padding: '10px 24px',
	},
	saveButton: {
		textTransform: 'none',
		fontSize: 14,
		fontFamily: BOGLE_MEDIUM,
		padding: '10px 24px',
		color: colors.WHITE,
		borderRadius: 24,
	},
};

export const addBulkItemsStyles = {
	header: {
		display: 'flex',
		alignItems: 'center',
	},
	title: {
		padding: '24px 0px 24px 16px',
		fontFamily: BOGLE_LIGHT,
		fontSize: '18px',
		color: colors.FONT_COLOR,
	},
	backButton: {
		color: colors.BLACK,
		marginLeft: '16px',
		cursor: 'pointer',
	},
	searchBox: {
		'& legend': { display: 'none' },
		'& fieldset': { top: 0 },
		width: '704px',
		height: '54px',
	},
	searchBoxInput: {
		style: {
			fontSize: '14px',
			fontFamily: BOGLE_REGULAR,
			color: colors.FONT_COLOR,
			fontWeight: 400,
		},
	},
	pasteItemLink: {
		textTransform: 'none',
		fontSize: '14px',
		fontFamily: BOGLE_MEDIUM,
		padding: 0,
		color: colors.PURPLE,
		backgroundColor: 'transparent',
		marginLeft: '14px',
	},
	resultBox: { flexGrow: 1, marginTop: '12px' },
	resultTitle: {
		fontFamily: BOGLE_LIGHT,
		fontSize: 18,
		color: colors.FONT_COLOR,
		marginTop: 24,
	},
	selectedChipText: {
		color: colors.WHITE,
		fontSize: '12px',
		fontFamily: BOGLE_MEDIUM,
		marginLeft: 4,
	},
	selectedChipStyle: {
		background: colors.PURPLE,
		width: '109px',
	},
	chipClearIcon: {
		color: colors.BLACK,
		fontSize: 'medium',
	},
	chipText: {
		color: colors.PURPLE,
		fontSize: '12px',
		fontFamily: BOGLE_MEDIUM,
		marginLeft: 4,
	},
	chipErrorText: {
		color: '#CB2022',
		fontSize: '12px',
		fontFamily: BOGLE_MEDIUM,
		marginLeft: 4,
	},
	chipStyle: { background: colors.WHITE, width: '109px' },
	chipBorderColor: colors.PURPLE,
	cancelButton: {
		textTransform: 'none',
		fontSize: 14,
		fontFamily: BOGLE_MEDIUM,
		borderRadius: 24,
		color: colors.PURPLE,
		padding: '10px 24px',
	},
	doneButton: {
		textTransform: 'none',
		fontSize: 14,
		fontFamily: BOGLE_MEDIUM,
		padding: '10px 24px',
		color: colors.WHITE,
		borderRadius: 24,
	},
};
